const words = require('lodash/words');
const capitalize = require('lodash/capitalize');

module.exports = function titlecase(value) {
  return words(value, /[^ ]+/g)
    .map(x => x.split('-').map(y => capitalize(y)).join('-'))
    .join(' ');
};
